import React, { useState } from 'react'
import { SearchIcon } from '../Icons'

const SearchInput = ({ placeholder, onSearch, className = '' }) => {
  const [searchValue, setSearchValue] = useState('')

  const handleChange = (e) => {
    const value = e.target.value
    setSearchValue(value)
    if (onSearch) {
      onSearch(value)
    }
  }

  return (
    <div className={`relative ${className}`}>
      <div className="absolute flex items-center left-2 inset-y-0 text-[#535862]">
        <SearchIcon />
      </div>
      <input
        type="text"
        value={searchValue}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-full h-[34px] border text-sm text-[#535862] pl-7 pr-3 rounded-[10px] border-[#F0F0F0] focus:outline-none focus:ring-1 focus:ring-[#DE3C7D] focus:border-[#DE3C7D]"
      />
    </div>
  )
}

export default SearchInput
